import { isNone, isEmpty } from '@ember/utils';

// TODO: these params/properties need some renaming to nicely accomodate event conversions
// (not only in this file, but also in the campaign/newsletter models and back-end responses)
export default function isValidConversion(
  conversion: undefined | null | boolean,
  conversionType: string,
  conversionSegmentId: string | null,
  conversionEventName: string,
  validConversionTimeframe: boolean,
) {
  let conversionChosen = typeof conversion === 'boolean';

  let validSegmentType = conversionType === 'enter' || conversionType === 'exit';
  let validSegment = !isNone(conversionSegmentId);

  let validEvent = !isEmpty(conversionEventName?.trim());

  return (
    conversionChosen && (!conversion || (validSegmentType && validSegment) || validEvent) && validConversionTimeframe
  );
}
